"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
require("../../scss/formInputs/text.scss");
const react_1 = __importStar(require("react"));
const error_message_1 = require("@hookform/error-message");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const inputErrorTranslations_1 = require("./helpers/inputErrorTranslations");
const Text = ({ label, classNamePrefix, placeholder, property, required, disabled, validations, isPassword, context, }) => {
    var _a;
    const { currentLocale } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    return (react_1.default.createElement("div", { className: `form-text-input-container ${classNamePrefix}-form-text-input-container` },
        label && (react_1.default.createElement("label", { className: `form-text-input-label ${classNamePrefix}-form-text-input-label` },
            label,
            required && react_1.default.createElement("span", { className: `${classNamePrefix}-form-text-input-required` }, " *"))),
        react_1.default.createElement("div", { className: `form-text-input-box ${classNamePrefix}-form-text-input-box` },
            react_1.default.createElement("input", Object.assign({ className: `form-text-input ${classNamePrefix}-form-text-input${(_a = (context.formState.errors[`${property}`] && ` ${classNamePrefix}-form-text-input-error`)) !== null && _a !== void 0 ? _a : ""}`, type: isPassword && !showPassword ? "password" : "text" }, context.register(property, {
                required: required ? inputErrorTranslations_1.translations[currentLocale].required : false,
                validate: validations,
                setValueAs: (value) => value.trim(),
            }), { placeholder: placeholder, autoComplete: "off", disabled: disabled })),
            isPassword && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: showPassword ? pro_light_svg_icons_1.faEye : pro_light_svg_icons_1.faEyeSlash, className: `form-show-password-icon-toggle ${classNamePrefix}-form-show-password-icon-toggle`, onClick: () => setShowPassword((prev) => !prev) }))),
        react_1.default.createElement(error_message_1.ErrorMessage, { errors: context.formState.errors, name: property, render: ({ message }) => react_1.default.createElement("p", { className: `${classNamePrefix}-form-text-input-error-message` }, message) })));
};
exports.Text = Text;
//# sourceMappingURL=Text.js.map